/// <reference path="../models/enums/customer-individual-medical-alert-type.enum.ts" />
import { Component, OnChanges } from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';

import { CustomerIndividualMedicalAlertType } from '../models/enums/customer-individual-medical-alert-type.enum';
import { CustomerIndividualMedicalAlert } from '../models/customer-individual-medical-alert.model';

@Component({
    selector: 'historical-customer-medical',
    templateUrl: './historical-customer-medical.html',
    inputs: ['customerNumberId']
})

export class HistoricalMedicalAlertsComponent extends BaseComponent implements OnChanges {
    public alerts: CustomerIndividualMedicalAlert[];
    public customerNumberId: number;

    private medicalAlertTypes: CustomerIndividualMedicalAlertType = new CustomerIndividualMedicalAlertType();

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.alerts !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumberId != null) {
            this.populateHistoricalAlerts(this.customerNumberId);
        }
    }

    populateHistoricalAlerts(customerNumberId: number) {
        var self = this;

        this.customerService.getHistoricalCustomerMedicalAlerts(customerNumberId)
            .subscribe(result => {
                this.alerts = result;
            },
            e => {
                this.alerts = [];
                console.log('error', e);
            },
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const alert of this.alerts) {
            alert.alertType = this.getValues(alert.customerIndividualMedicalAlertTypeId, this.medicalAlertTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }
}
